/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't save the league final." |
*
* @param {League_Final_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_error = /** @type {((inputs?: League_Final_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer la finale de ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo guardar la final de liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar a final da liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare la finale del campionato.")
	return /** @type {LocalizedString} */ ("Couldn't save the league final.")
});